export default [
  {
    path: '/purchase/:key?',
    name: 'purchasePage',
    component: () => import(/*webpackChunkName:'purchase'*/ '@/views/purchase/index.vue'),
    meta: {},
  },
];
